import React, { useEffect, useState } from 'react';
import { IonCard, IonCardHeader } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

import '../CasinoNew/CasinoNew.scss';
import { RootState } from '../../../models/RootState';
import { DcGameNew, IndCasinoGame } from '../../../models/dc/DcGame';
import CasinoView from '../../../constants/CasinoView';
import { INDIAN_CASINO_GAMES } from '../../../constants/IndianCasinoGames';
import { AxiosResponse } from 'axios';
import API from '../../../api';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Typography } from '@material-ui/core';
import { getCurrencyTypeFromToken } from '../../../store';
import SVLS_API from '../../../svls-api';

type StoreProps = {
  loggedIn: boolean;
  // loggedInUserStatus: any;
};

const WebBanners = CasinoView.IND_CASINO_WEB_BANNERS;
const MobileBanners = CasinoView.IND_CASINO_MOBILE_BANNERS;

const IndianCasinoPage: React.FC<StoreProps> = (props) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const { loggedIn } = props;
  const [games, setGames] = useState<IndCasinoGame[]>([]);
  const [dcGames, setDcGames] = useState<DcGameNew[]>([]);

  const history = useHistory();

  const setDialogShow = (show: boolean) => {
    setShowDialog(show);
  };

  useEffect(() => {
    if (loggedIn) {
      const claims = sessionStorage.getItem('jwt_token').split('.')[1];
      const userStatus = JSON.parse(window.atob(claims)).status;

      if (userStatus === 0 || userStatus === 3) {
        return history.push(`/home`);
      }

      // history.push('/indian_casino/live');
    }
  }, [loggedIn]);

  // const getFcGames = async () => {
  //   let response: AxiosResponse<IndCasinoGame[]>;
  //   if (loggedIn) {
  //     response = await API.get('/dc/indian-casino/filtered-list', {
  //       // params: {
  //       //   currencyType: getCurrencyTypeFromToken(),
  //       // },
  //       headers: {
  //         Authorization: sessionStorage.getItem('jwt_token'),
  //       },
  //     });
  //   } else {
  //     response = await API.get('/dc/indian-casino/filtered-list');
  //   }

  //   if (response.status == 200) {
  //     setGames(response.data);
  //   }

  //   // .sort((a, b) => {
  //   //   const x = a.gameName.toLowerCase().includes('virtual');
  //   //   const y = b.gameName.toLowerCase().includes('virtual');
  //   //   return x === y ? 0 : x ? 1 : -1;
  //   // })
  // };

  const getIndianCasinoGameUrl = (gameCode) => {
    if (loggedIn) {
      history.push(`/indian_casino/live/${gameCode}`);
    } else {
      setDialogShow(true);
    }
  };

  useEffect(() => {
    // getFcGames();
    getDcGames();
  }, [loggedIn]);

  const getDcGames = async () => {
    const response: AxiosResponse<DcGameNew[]> = await SVLS_API.get(
      '/catalog/v2/categories/indian-casino/games/',
      {
        params: {
          providerId: 'RG',
        }
      },
    );

    setDcGames(response?.data?.filter((g) => g.providerName === 'RG'));
  };

  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      // status check
      // if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
      //   history.push(`/home`);
      // }
      history.push(
        `/dc/gamev1.1/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
          gameId.toString()
        )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
      );
    } else {
      setDialogShow(true);
    }
  };

  return (
    <div className="dc-page-bg">
      <Carousel
        className="casino-web-banners"
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        showThumbs={false}
        showStatus={false}
      >
        {WebBanners.map((banner) => (
          <div key={banner.text + 'container'}>
            <img
              className="banner-images"
              src={banner.image}
              key={banner.text + 'image'}
              alt={'banner'}
            />
          </div>
        ))}
      </Carousel>
      <Carousel
        className="casino-mobile-banners"
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        showThumbs={false}
        showStatus={false}
      >
        {MobileBanners.map((banner) => (
          <div key={banner.text + 'container'}>
            <img
              className="banner-images"
              src={banner.image}
              key={banner.text + 'image'}
              alt={'banner'}
            />
          </div>
        ))}
      </Carousel>

      <div className="dc-ctn">
        <div className="dc-games-ctn">
          <>
            {dcGames.length > 0 &&
              dcGames.map((g, idx) => (
                <Card
                  className="dc-ion-card"
                  onClick={() =>
                    getGameUrl(
                      g.gameId,
                      g.gameName,
                      g.gameCode,
                      g.providerName,
                      g.subProviderName
                    )
                  }
                >
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      alt={g.gameName}
                      className="dc-card-media"
                      image={g.urlThumb ? g.urlThumb : ''}
                      title={g.gameName}
                    />
                    <CardContent className="dc-card-ctn">
                      <Typography gutterBottom className="game-name">
                        {g.gameName}
                      </Typography>
                      {loggedIn && g.minLimits && g.maxLimits ? (
                        <Typography variant="caption" className="game-range">
                          {g.minLimits} - {g.maxLimits}
                        </Typography>
                      ) : null}
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))}

            {games.map((g, idx) => (
              <Card
                className="dc-ion-card"
                onClick={() => getIndianCasinoGameUrl(g.Game_id)}
              >
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt={g.Game_name}
                    className="dc-card-media"
                    image={g.Url ? g.Url : ''}
                    title={g.Game_name}
                  />
                  <CardContent className="dc-card-ctn">
                    <Typography gutterBottom className="game-name">
                      {g.Game_name}
                    </Typography>
                    {loggedIn && g.minLimits && g.maxLimits ? (
                      <Typography variant="caption" className="game-range">
                        {g.minLimits} - {g.maxLimits}
                      </Typography>
                    ) : null}
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </>
        </div>
      </div>

      <Dialog
        open={showDialog}
        onClose={() => setDialogShow(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
      >
        <DialogTitle id="form-dialog-title">Notice</DialogTitle>
        <DialogContent>
          <div className="dc-dialog-body">You have to be logged in to play</div>
        </DialogContent>
        <DialogActions className="dc-dialog-actions">
          <Button
            onClick={() => setDialogShow(false)}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  let status = 0;
  if (state.auth.loggedIn) {
    status = JSON.parse(
      window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
    ).status;
  }
  return {
    loggedIn: state.auth.loggedIn,
    loggedInUserStatus: status,
  };
};

export default connect(mapStateToProps, null)(IndianCasinoPage);
